<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.users_keywords") }}
    </div>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="user_id" :label='$vuetify.lang.t("$vuetify.ai_response.user_id")' dense outlined :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.user_id')
            ),
          ]">
          </v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="member_id" :label='$vuetify.lang.t("$vuetify.ai_response.member_id")' dense outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text " outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-btn class="float-right ml-2" color="primary" @click="getRecommendedItems" dark>
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
        <v-card-title>
        </v-card-title>

      </v-row>
    </v-form>
    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading">
        <Loader class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
        style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{$vuetify.lang.t("$vuetify.ai_response.users_keywords")}}
          </div>
        </v-container>

        <v-container>
          <v-row v-if=" usersKeywords && usersKeywords.length > 0">
            <v-col>
              <v-chip v-for="keyword in usersKeywords" :key="keyword" class="mx-1 my-1" color="primary" text-color="white">
                {{ keyword }}
              </v-chip>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.no_keywords_found") }}
            </span>
          </v-col>

        </v-container>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">
              {{ $vuetify.lang.t("$vuetify.ai_response.close") }}
            </v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { USERS_KEYWORDS, ADD_ALERT} from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";

export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      usersKeywords: []
    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  methods: {
    ...mapActions("ai_response", [USERS_KEYWORDS]),
    ...mapActions("alert", [ADD_ALERT]),
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      this.openResponseModal = true
      this.responseLoading = true
      this.USERS_KEYWORDS({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
      }).then(
        (response) => {
          this.responseLoading = false
          this.usersKeywords = response.data.detail.response
        },
        (error) => {
          this.openResponseModal = false
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
          console.error("error", error)
        }
      );
    },
  }
};
</script>

<style scoped>
        .product-card {
          height: 300px; 
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
        }
        .card-content {
          padding: 4px;
        }
    
        .card-content .v-card-title {
          margin-bottom: 0;
          font-size: 16px;
        }
    
        .card-content .v-card-subtitle {
          margin-bottom: 8px;
        }
</style>
